import { Glyph } from '../../common/Glyph';

import { useWebAppSettings } from '../../../store/web-app-settings/useWebAppSettings';

import { glyph } from '../../../theme/glyph';
import { theme } from '../../../theme/theme';
import styles from './MainNavHomeyItem.module.css';

export interface MainNavHomey {
  id: string;
  name: string;
  modelName?: string | null;
  modelImage?: {
    light?: string | null;
    dark?: string | null;
  } | null;
}

interface MainNavHomeyItemProps {
  homey: MainNavHomey;
  isSelected: boolean;
}

/**
 * Content of a row in the My Homeys submenu of the profile menu, with the Homey's image, name and
 * model.
 */
export function MainNavHomeyItem(props: MainNavHomeyItemProps) {
  const { settings } = useWebAppSettings();

  const isDarkMode = settings.theme.darkMode === true;
  const imageUrl = isDarkMode ? props.homey.modelImage?.dark : props.homey.modelImage?.light;

  return (
    <span className={styles.root}>
      {imageUrl != null && <img className={styles.image} src={imageUrl} alt="" />}

      <span className={styles.text}>
        <span className={styles.name}>{props.homey.name}</span>

        {props.homey.modelName != null && (
          <span className={styles.model}>{props.homey.modelName}</span>
        )}
      </span>

      {props.isSelected && (
        <Glyph
          className={styles.check}
          source={glyph.core.checkmark}
          color={theme.color.highlight}
        />
      )}
    </span>
  );
}
